import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from '../Section';
import { TransformCTA } from '../TransformCTA';
import { volumes } from '../../data/volumes';
export function Volumes() {
  return <Section tone="white" eyebrow="The content" title="What is inside Renal Decision Desk™?" subtitle="A complete clinical decision-navigation system organized around the situations that create the most uncertainty in everyday renal practice." data-id="element-304" data-mp="2x08jm9pj3nsb">
      <div className="space-y-5 sm:space-y-6" data-id="element-305" data-mp="2ja52ty9f4ma9">
        {volumes.map(volume => <article key={volume.number} className="overflow-hidden rounded-3xl border border-ink-line bg-cream" data-id="element-306" data-mp="2eas68lsqw0uh">
            <div className="flex items-center gap-3 px-5 py-4 sm:px-7" style={{
          backgroundColor: volume.accent
        }} data-id="element-307" data-mp="29d0ebrs3oeqa">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/15 font-display text-lg font-bold text-white" data-id="element-308" data-mp="20b10178gzor1">
                {volume.number}
              </span>
              <div className="min-w-0" data-id="element-309" data-mp="37w2t2xev6ba1">
                <p className="text-[10.5px] font-extrabold uppercase tracking-[0.18em] text-white/70" data-id="element-310" data-mp="37x4f1wxf4i6j">
                  {volume.label}
                </p>
                <h3 className="font-display text-[19px] font-bold leading-tight text-white sm:text-2xl" data-id="element-311" data-mp="2y69serg9fgkk">
                  {volume.title}
                </h3>
              </div>
            </div>

            <div className="p-5 sm:p-7" data-id="element-312" data-mp="3qv8fm2z8p8wq">
              <p className="font-display text-[17px] font-semibold italic leading-snug text-ink sm:text-xl" data-id="element-313" data-mp="3qtxa9yq5bt3i">
                {volume.tagline}
              </p>
              <p className="mt-3 text-[14.5px] leading-relaxed text-ink-soft" data-id="element-314" data-mp="3hua65561896r">
                {volume.intro}
              </p>

              <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[0.16em] text-ink-soft" data-id="element-315" data-mp="21f8x3v9qe74f">
                Inside:
              </p>
              <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-316" data-mp="26d0o8n2jxp7k">
                {volume.items.map(item => <li key={item} className="flex items-start gap-2.5 rounded-xl bg-white px-3.5 py-2.5 ring-1 ring-ink-line" data-id="element-317" data-mp="70233qav7iv0">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                color: volume.accent
              }} aria-hidden="true" data-id="element-318" data-mp="2791vcelusno" />
                    <span className="text-[13.5px] font-medium leading-snug text-ink" data-id="element-319" data-mp="3pbowjpmtupud">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <p className="mt-5 rounded-2xl px-4 py-3.5 text-[14px] font-semibold leading-snug text-white" style={{
            backgroundColor: volume.accent
          }} data-id="element-320" data-mp="3bea040y5phsw">
                {volume.closing}
              </p>
            </div>
          </article>)}
      </div>

      <TransformCTA label="I want all 6 decision volumes" sub="6 specialized volumes + 5 premium bonuses • Instant digital access" data-id="element-321" data-mp="2rkjwu50s367b" />
    </Section>;
}